<script>
import { baseCompile } from "@vue/compiler-core";
import axios from "axios";
import {
    default as isMobilePhone,
    getBasePath,
    getDistance,
    IsNissan,
    getLocation,
    getQueryString,
    getUserPhone,
    finishTask,
    getConfig,
    isUser,
    findInStockAll,
} from "./utils";
import carNames from "./assets/car.json";
import { getBase } from "./router";
import "./utils/WebglMessageEvent";
let stepStartTime = null;
let driveStartTime = null;
export default {
    data() {
        return {
            carStates: {
                car: "",
                carName: "",
                version: "",
                sceneId: 0,
                carSeries: "",
                carSeriesName: "",
                carSeriesId: "",
                carType: "",
                defaultColor: "",
                defaultInnerColor: "",
                financeType: "",
                fov: 39,
                innerColor: "",
                innerColorcode: "",
                outColor: "",
                outColorcode: "",
                pandectFov: 39,
                loan_prop: "",
                step: 1,
                showMarker: true,
                isScene: true,
                options: [],
                assembles: [],
                carTypeId: "",
                ue4: false,
                insideLocationId: 0,
                price: "",
                versionPrice: "",
                isConfigured: false,
                loaded: false,
                preferencesUrl: "",
                privacyUrl: "https://www.dongfeng-nissan.com.cn/about/privacy",
                media: {
                    list: [],
                    title: "",
                },
                curOption: "",
                isDriveModel: false,
                iosTip: false,
                isPerspective: false,
                perspectiveState: "",
                fullScreen: false,
                pandectList: [],
                firstPerspective: false,
                showStaff: true,
                totalStep: 5,
                nissanCarSeriesId: "",
                newLoading: false,
                tabs: [],
                status: "",
                pageTitle: "",
                blockRightButtons: false,
                seatLaydown: false,
                isExterior: true,
                showSceneBtn: true,
                preferential: 0,
                policy: null,
                source_page: '',
                stockAll: []
            },
            configures: {
                carVersion: "",
                inside: "",
                outside: "",
                options: "",
                config: "",
                nav: "",
                scene: "",
            },
            initDefaulted: false,
            outColorList: [],
            insideColorList: [],
            optionList: [],
            assembleList: [],
            versionList: [],
            addOptionFun: null,
            global_vars: GLOBAL_VARS,
            address: {},
            provinces: [],
            names: [
                "version",
                "outside",
                "inside",
                "options",
                "pandect",
                "scene",
            ],
            isNissan: IsNissan(),
            userPhone: "",
            activityTime: 0,
        };
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                this.configures.nav &&
                    dndcAnalytics("send", "pageview", {
                        page: location.href,
                        title: this.configures.nav.router
                            .find((n) => n.name == this.carStates.status)
                            .title.replace("选择", ""),
                    });
            },
            // 深度观察监听
            deep: true,
        },
        "carStates.version"(newValue, oldValue) {
            this.outColorList = this.getOutsideColorList();
            this.insideColorList = this.getInsideColorList();
            this.carStates.pandectList = this.getPandectList();
            this.optionList = this.getOptionList();
            this.updatePrice();
        },
        "carStates.carType"(newValue, oldValue) {
            this.outColorList = this.getOutsideColorList();
            this.carStates.pandectList = this.getPandectList();
            this.optionList = this.getOptionList();
            this.updatePrice();
        },
        "carStates.options": {
            handler: function () {
                this.carStates.pandectList = this.getPandectList();
                this.updatePrice();
            },
            immediate: true,
            deep: true,
        },
        "carStates.assembles": {
            handler: function () {
                this.carStates.pandectList = this.getPandectList();
                this.updatePrice();
            },
            immediate: true,
            deep: true,
        },
        "carStates.outColor": {
            handler: function (val, oldVal) {
                this.carStates.pandectList = this.getPandectList();
                if (val != oldVal) {
                    this.insideColorList = this.getInsideColorList();
                    let tem = this.insideColorList.find(
                        (l) => l.name == this.carStates.innerColor
                    );
                    if (!tem && this.insideColorList[0]) {
                        this.carStates.innerColor =
                            this.insideColorList[0].name;
                        this.carStates.innerColorcode =
                            this.insideColorList[0].code;
                    }
                }
                this.updatePrice();
            },
            immediate: true,
            deep: true,
        },
        "carStates.innerColor": {
            handler: function () {
                this.carStates.pandectList = this.getPandectList();
            },
            immediate: true,
            deep: true,
        },
        "carStates.step": {
            handler: function (val, oldVal) {
                if (!this.configures.nav) {
                    this.carStates.status = "version";
                    this.carStates.pageTitle = "版本页";
                    return;
                }
                let titles = {};
                this.configures.nav.router.filter((n) => {
                    titles[n.id] = n.title.replace("选择", "") + "页";
                });
                this.carStates.pageTitle = titles[val];
                this.carStates.showStaff = val == 1;
                if (val != oldVal) {
                    if (stepStartTime) {
                        let codes = {
                            version: "v_20230511171626_x010",
                            outside: "v_20230511171626_b011",
                            inside: "v_20230511171626_o012",
                            options: "view_vrcar_goods_stay_23031128w",
                            assemble: "view_car_vr_optional_see_23201846p032",
                            pandect: "view_car_vr_customized_see_23201846q024",
                        };
                        this.track(codes[this.carStates.status], {
                            page_title: titles[oldVal],
                            event_duration:
                                new Date().getTime() / 1000 -
                                stepStartTime / 1000,
                        });
                    }
                    stepStartTime = new Date().getTime();
                }
                if (val >= 3) {
                    this.carStates.isConfigured = true;
                    if (val == 3) this.carStates.isPerspective = false;
                }
                let aStr = "";
                if (this.carStates.assembles.length > 0) {
                    aStr += "选装";
                    this.carStates.assembles.filter(
                        (av) => (aStr = aStr.concat(av.name + ";"))
                    );
                }
                if (this.carStates.options.length > 0) {
                    aStr += "精品";
                    this.carStates.options.filter(
                        (ov) => (aStr = aStr.concat(ov.name + ";"))
                    );
                }
                if (val == this.carStates.totalStep) {
                    this.track("c_20230511171626_b019", {
                        page_title: oldVal == 3 ? "内饰页" : "精品页",
                        btn_name: "完成定制",
                        car_version: this.carStates.carName,
                        car_outside: this.carStates.outColor,
                        car_inside: this.carStates.innerColor,
                        car_personal: aStr,
                    });
                }
                this.carStates.status = this.configures.nav
                    ? this.configures.nav.router[val - 1].name
                    : "version";
            },
            immediate: true,
            deep: true,
        },
        "carStates.insideLocationId": {
            handler: function (val) {
                if (this.carStates.step == 3) {
                    let names = {
                        frontchair: "前排主驾驶",
                        frontchair_b: "前排副驾驶",
                        backchair: "后排",
                    };
                    this.track("c_20230511171626_r014", {
                        page_title: "内饰页",
                        btn_name: names[val],
                    });
                }
            },
            immediate: true,
            deep: true,
        },
        "carStates.isDriveModel": {
            handler: function (val, oldVal) {
                if (!this.carStates.ue4) {
                    return;
                }
                if (val != oldVal && oldVal) {
                    this.carStates.showStaff = true;
                    if (!driveStartTime) {
                        driveStartTime = new Date().getTime();
                    } else {
                        this.track("v_20230511171626_p025", {
                            page_title: "驾驶模式",
                            event_duration:
                                (new Date().getTime() - driveStartTime) / 1000,
                        });
                    }
                }
                else {
                    this.carStates.showStaff = false;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    provide() {
        return {
            carStates: this.carStates,
            configures: this.configures,
            loadConfigure: this.loadConfigure,
            outColorList: () => this.outColorList,
            insideColorList: () => this.insideColorList,
            optionList: () => this.optionList,
            assembleList: () => this.assembleList,
            versionList: () => this.versionList,
            saveInitData: this.saveInitData,
            global_vars: this.global_vars,
            selectOutside: this.selectOutside,
            selectInside: this.selectInside,
            selectVersion: this.selectVersion,
            addOption: this.addOption,
            addAssemble: this.addAssemble,
            setAddOption: this.setAddOption,
            getPandectList: this.getPandectList,
            getProvincesList: this.getProvincesList,
            getCitiesList: this.getCitiesList,
            getDealersList: this.getDealersList,
            address: () => this.address,
            getCurLocation: this.getCurLocation,
            checkPhone: this.checkPhone,
            testDrive: this.testDrive,
            toThousands: this.toThousands,
            initDefaultConfig: this.initDefaultConfig,
            getShowLink: this.getShowLink,
            onStepUpdate: this.onStepUpdate,
            stepBarVisible: this.stepBarVisible,
            driveModel: this.driveModel,
            jumpStep: this.jumpStep,
            track: this.track,
            showMarker: this.showMarker,
            setScene: this.setScene,
            isNissan: this.isNissan,
            switchWebgl: this.switchWebgl,
            isInDouyin: this.isInDouyin,
            getUserPhone: this.getUserPhone,
            activityTime: () => this.activityTime,
        };
    },
    methods: {
        /**
         * @description: 保存配置信息
         * @param {*} data
         * @param {*} update
         * @return {*}
         */
        saveInitData(data, update = true) {
            try {
                let keys = Object.keys(data);
                if (
                    this.configures.config &&
                    this.configures.config.blockOption == true &&
                    data.step == 4
                ) {
                    data.step =
                        this.$router.currentRoute.value.fullPath.indexOf(
                            "inside"
                        ) != -1
                            ? 5
                            : 3; //跳过精品模块
                }
                keys.filter((key) => {
                    if (this.carStates.hasOwnProperty(key)) {
                        this.carStates[key] = data[key];
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        stepBarVisible(index) {
            if (index < this.carStates.totalStep) {
                if (index == 3) {
                    return (
                        this.configures.config &&
                        this.configures.config.blockOption != true
                    );
                }
                return true;
            }
            return false;
        },
        /**
         * @description: 判断手机号码是否正确
         * @param {*} phone
         * @return {*}
         */
        checkPhone(phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
                return false;
            }
            return true;
        },
        /**
         * @description: 更新价格
         * @return {*}
         */
        updatePrice() {
            if (this.configures["carVersion"]) {
                this.versionList = [
                    ...this.configures["carVersion"].config.filter(
                        (value) => value.show || value.show == undefined
                    ),
                ];
                let price = this.configures.carVersion.config.find(
                    (value) => value.code == this.carStates.version
                ).price;
                this.carStates.versionPrice = price;
                this.configures.outside.colorList.filter((o) => {
                    if (o.code == this.carStates.outColorcode && o.price) {
                        price += o.price;
                    }
                });
                this.carStates.options.filter((option) => {
                    price += option.price;
                });
                this.carStates.assembles.filter((assemble) => {
                    price += assemble.price;
                });
                this.carStates.price =
                    this.configures.config && this.configures.config.blockPrice
                        ? "***"
                        : price;
                let { preferential, policy } = this.configures.carVersion.config.find(
                    (value) => value.code == this.carStates.version
                );
                this.carStates.preferential = preferential ?? this.carStates.preferential;
                this.carStates.policy = policy ?? this.carStates.policy;
            }
        },
        /**
         * @description: 添加精品
         * @param {*} curOption 精品信息
         * @return {*}
         */
        addOption(curOption) {
            if (curOption.code) this.addOptionFun(curOption.code);
            else {
                let is_all = 0;
                if (this.carStates.options.indexOf(curOption) == -1) {
                    this.carStates.options.push(curOption);
                    this.saveInitData({ curOption }, false);
                    is_all = 1;
                } else {
                    this.carStates.options.splice(
                        this.carStates.options.indexOf(curOption),
                        1
                    );
                }
                this.track(
                    "click_vrcar_goods_23031110n004",
                    {
                        page_title: this.carStates.pageTitle,
                        btn_name: curOption.name,
                        is_all,
                    },
                    true
                );
            }
        },
        /**
         * @description: 添加精品
         * @param {*} curOption 精品信息
         * @return {*}
         */
        addAssemble(curOption) {
            if (this.carStates.assembles.indexOf(curOption) == -1) {
                this.carStates.assembles.push(curOption);
                this.saveInitData({ curOption }, false);
            } else {
                this.carStates.assembles.splice(
                    this.carStates.assembles.indexOf(curOption),
                    1
                );
            }
            this.track(
                "click_car_vr_optional_23201846n031",
                {
                    page_title: this.carStates.pageTitle,
                    btn_name: curOption.name,
                },
                true
            );
        },
        /**
         * @description: 设置添加精品方法
         * @param {*} fun
         * @return {*}
         */
        setAddOption(fun) {
            this.addOptionFun = fun;
        },
        /**
         * @description: 获取外观颜色列表
         * @return {*}
         */
        getOutsideColorList() {
            if (!this.configures["outside"]) {
                return [];
            }
            let colorList = this.configures["outside"].colorList;
            let { version, carType, outColorcode, outColor } = this.carStates;
            if (this.configures["outside"].colorList instanceof Array) {
                colorList = this.configures["outside"].colorList.find(
                    (item) => item.version != undefined
                )
                    ? this.configures["outside"].colorList.filter(
                        (v) => !v.version || v.version.indexOf(carType) == -1
                    )
                    : colorList;
            } else {
                colorList = this.configures["outside"].colorList[version];
            }
            if (colorList && (!colorList.find((c) => c.code == outColorcode) || !colorList.find((c) => c.name == outColor))) {
                this.saveInitData({
                    outColorcode: colorList[0].code,
                    outColor: colorList[0].name,
                });
            }

            return colorList;
        },
        /**
         * @description: 获取内饰颜色列表
         * @return {*}
         */
        getInsideColorList() {
            if (!this.configures["inside"]) {
                return [];
            }
            let { carType } = this.carStates;
            let list = this.configures["inside"].colorList.find(
                (inside) => inside.carType == carType
            ).colorList;
            let condition = this.configures["inside"].condition;
            if (!condition) {
                return list;
            }
            let insideColorList = [];
            list.filter((color) => {
                condition.filter((c) => {
                    console.log(
                        "this.carStates.outColor:",
                        this.carStates.outColor
                    );
                    if (
                        c.outSideColor.split("、").find(o => o == this.carStates.outColor) &&
                        c.inSideColor.split("、").indexOf(color.name) != -1
                    ) {
                        insideColorList.push(color);
                    }
                });
            });

            return insideColorList;
        },
        /**
         * @description: 获取精品列表
         * @return {*}
         */
        getOptionList() {
            if (!this.configures["options"]) {
                return [];
            }
            let { carType } = this.carStates;
            return this.configures["options"].optionals.filter(
                (option) =>
                    !option.version || option.version.indexOf(carType) == -1
            );
        },
        /**
         * @description: 获取配置完成信息列表
         * @return {*}
         */
        getPandectList() {
            let {
                outColorcode,
                carName,
                version,
                outColor,
                innerColor,
                innerColorcode,
                options,
                assembles,
            } = this.carStates;
            let { thumbnails } = this.insideColorList.find(
                (color) => color.code == innerColorcode
            ) ?? { thumbnails: "" };
            const { car } = this.$route.params;
            console.log(
                "this.global_vars.online3D:",
                this.global_vars.online3D
            );
            let list = [
                {
                    type: "版本",
                    icon: `${this.global_vars.online3D}static/${this.getCarName(
                        car
                    )}/mobile/images/car/${version.indexOf("e-POWER") != -1 ? "epower/" : ""
                        }${outColorcode}.jpg`,
                    title: carName,
                    des: this.carStates.carSeries == 'VX6' && !isMobilePhone() ? `厂商指导价：¥${this.toThousands(this.carStates.versionPrice)}` : `${this.carStates.carSeries == 'VX6' ? '厂商指导价' : ''}¥${this.toThousands(this.carStates.versionPrice)}`,
                    step: 1,
                },
            ];
            const o = this.configures.outside
                ? this.configures.outside.colorList.find(
                    (o) => o.code == outColorcode
                ) ?? {}
                : {};
            const inside = this.configures.inside
                ? this.configures.inside.colorList.find(
                    (o) => o.code == innerColor
                ) ?? {}
                : {};
            list.push({
                type: "外观",
                icon: o.thumbnails
                    ? this.global_vars.online3D + o.thumbnails
                    : `${this.global_vars.online3D
                    }static/common/images/outside/small/${outColor.replace(
                        "/",
                        " "
                    )}.jpg`,
                title: outColor,
                des: o.price ? "¥" + this.toThousands(o.price) : "",
                step: 2,
            });
            list.push({
                type: "内饰",
                icon: `${this.global_vars.online3D}${thumbnails}`,
                title: innerColor,
                des: inside.price ? "¥" + this.toThousands(inside.price) : "",
                step: 3,
            });
            if (!isMobilePhone()) {
                let assembleList = this.configures.options.assemble ?? [];
                for (var j = 0; j < assembleList.length; j++) {
                    list.push({
                        type: j == 0 ? "选装" : "",
                        icon: `${this.global_vars.online3D}${assembleList[j].thumbnails}`,
                        title: assembleList[j].name,
                        des: "¥" + this.toThousands(assembleList[j].price),
                        step: this.configures.nav.router.find(
                            (v) => v.name == "assemble"
                        ).id,
                        data: assembleList[j],
                        checked: assembles.indexOf(assembleList[j]) != -1,
                    });
                }
                for (var i = 0; i < this.getOptionList().length; i++) {
                    list.push({
                        type: i == 0 ? "精品" : "",
                        icon: `${this.global_vars.online3D}${this.getOptionList()[i].thumbnails
                            }`,
                        title: this.getOptionList()[i].name,
                        des:
                            "¥" +
                            this.toThousands(this.getOptionList()[i].price),
                        step: this.configures.nav.router.find(
                            (v) => v.name == "options"
                        ).id,
                        data: this.getOptionList()[i],
                        checked: options.indexOf(this.getOptionList()[i]) != -1,
                    });
                }
            } else {
                for (var i = 0; i < options.length; i++) {
                    list.push({
                        type: i == 0 ? "精品" : "",
                        icon: `${this.global_vars.online3D}${options[i].thumbnails}`,
                        title: options[i].name,
                        des: "¥" + this.toThousands(options[i].price),
                        step: this.configures.nav.router.find(
                            (v) => v.name == "options"
                        ).id,
                    });
                }
                for (var j = 0; j < assembles.length; j++) {
                    list.push({
                        type: j == 0 ? "选装" : "",
                        icon: `${this.global_vars.online3D}${assembles[j].thumbnails}`,
                        title: assembles[j].name,
                        des: "¥" + this.toThousands(assembles[j].price),
                        step: this.configures.nav.router.find(
                            (v) => v.name == "assemble"
                        ).id,
                    });
                }
            }

            return list;
        },
        /**
         * @description: 根据经纬度获取地址信息
         * @return {*}
         */
        async getCurLocation() {
            let { latitude: lat, longitude: lng } = this.address;
            let { data } = await axios({
                method: "get",
                url: "https://digital-official-api.dongfeng-nissan.com.cn/nissan/api/map/parse/coordinate2address",
                dataType: "json",
                crossDomain: true,
                cache: false,
                params: {
                    lat,
                    lng,
                },
            });
            return data;
        },
        /**
         * @description: 获取省份列表
         * @return {*}
         */
        async getProvincesList() {
            let {
                data: { result },
            } = await axios.get(
                getBasePath() + this.global_vars.dongfengApi.provinces
            );
            let list = [];
            result.filter((value) => {
                list.push({
                    value: value.id,
                    label: value.name,
                    city_list: value.city_list,
                });
            });
            this.provinces = list;
            return list;
        },
        /**
         * @description: 通过省份id获取城市列表
         * @param {*} province_id
         * @return {*}
         */
        async getCitiesList(province_id) {
            let data = this.provinces.find(
                (value) => value.value == province_id
            ).city_list;
            let list = [];
            data.filter((value) => {
                list.push({
                    value: value.id,
                    label: value.name,
                });
            });
            return list;
        },
        /**
         * @description: 通过城市id获取专营店列表
         * @param {*} city_id
         * @return {*}
         */
        async getDealersList(city_id) {
            let {
                data: { result },
            } = await axios({
                method: "get",
                url: getBasePath() + this.global_vars.dongfengApi.dealers,
                dataType: "json",
                crossDomain: true,
                cache: false,
                params: {
                    city_id,
                },
            });
            let list = [];
            result.filter((value) => {
                if (value.car_series_ids.indexOf(this.carStates.carSeriesId) != -1) {
                    list.push({
                        value: value.code,
                        label: value.name,
                        address: value.address,
                        latitude: value.latitude,
                        longitude: value.longitude,
                        distance: Math.round(
                            getDistance(
                                this.address.latitude,
                                this.address.longitude,
                                value.latitude,
                                value.longitude
                            )
                        ),
                    });
                }
            });
            list.sort((a, b) => a.distance - b.distance);
            return list;
        },
        /**
         * @description: 选择版本
         * @param {*} item
         * @return {*}
         */
        selectVersion(item, reset = false) {
            if (!item) {
                this.initDefaultConfig();
                this.saveInitData({
                    step: 1,
                });
                if (this.carStates.isConfigured) {
                    window.document
                        .getElementsByClassName("car")[0]
                        .contentWindow.postMessage(
                            WebglMessageEvent.REMOVE_ALL_ITEMS
                        );
                    window.document
                        .getElementsByClassName("car")[0]
                        .contentWindow.postMessage(
                            WebglMessageEvent.CLOSE_AMIMATIONS
                        );
                }
                this.carStates.isConfigured = false;
                this.saveInitData({ options: [] }, true);
                return;
            }
            let {
                name: carName,
                id: carType,
                code: version,
                carId: carTypeId,
            } = item;
            this.saveInitData({
                carName,
                carType,
                carTypeId,
                version,
            });
            this.getOutsideColorList();
            let { code: innerColorcode, name: innerColor } =
                this.getInsideColorList().find(
                    (insideColor) =>
                        insideColor.name == this.carStates.innerColor
                ) ?? this.getInsideColorList()[0];
            this.saveInitData({
                innerColorcode,
                innerColor
            })
            if (this.carStates.isConfigured) {
                window.document
                    .getElementsByClassName("car")[0]
                    .contentWindow.postMessage(
                        WebglMessageEvent.REMOVE_ALL_ITEMS
                    );
                window.document
                    .getElementsByClassName("car")[0]
                    .contentWindow.postMessage(
                        WebglMessageEvent.CLOSE_AMIMATIONS
                    );
            }
            this.carStates.isConfigured = false;
            this.saveInitData({ options: [] }, true);
            this.track("c_20230511171626_a001", {
                car_version: item.name,
                page_title: "版本页",
            });
            if (reset) this.updateDefualtColor();
        },
        /**
         * @description: 更新默认内外观颜色
         * @return {*}
         */
        updateDefualtColor() {
            this.carStates.outColor = this.carStates.defaultColor;
            this.carStates.insideColor = this.carStates.defaultInnerColor;
            let { name: outColor, code: outColorcode } =
                this.getOutsideColorList().find(
                    (color) => color.name == this.carStates.defaultColor
                ) ?? this.getOutsideColorList()[0];
            let { code: innerColorcode, name: innerColor } =
                this.getInsideColorList().find(
                    (insideColor) =>
                        insideColor.name == this.carStates.defaultInnerColor
                ) ?? this.getInsideColorList()[0];
            this.saveInitData({
                outColor,
                outColorcode,
                innerColorcode,
                innerColor,
            });
        },
        /**
         * @description: 选择外观颜色
         * @param {*} item
         * @return {*}
         */
        selectOutside(item) {
            let { name: outColor, code: outColorcode } = item;
            this.saveInitData({
                outColor,
                outColorcode,
            });
            this.track("c_20230511171626_k013", {
                page_title: this.carStates.pageTitle,
                car_outside: item.name,
                btn_name: item.name,
            });
        },
        /**
         * @description: 选择内饰颜色
         * @param {*} item
         * @return {*}
         */
        selectInside(item) {
            let { code: innerColorcode, name: innerColor } = item;
            this.saveInitData({
                innerColor,
                innerColorcode,
            });
            this.track("c_20230511171626_d015", {
                page_title: this.carStates.pageTitle,
                car_inside: item.name,
                btn_name: item.name,
            });
        },
        getCarName(car) {
            let temCar = carNames.list.find((carName) => {
                var temName = carName.names.find((name) => name == car);
                if (temName) {
                    return carName.car;
                }
            });
            car = temCar ? temCar.car : car;
            return car;
        },
        /**
         * @description: 读取车型配置表
         * @param {*} car
         * @return {*}
         */
        async loadConfigure(car) {
            this.carStates.newLoading = true;
            findInStockAll(GLOBAL_VARS.BASE_ENV, this.getCarName(car), (data) => {
                this.carStates.stockAll = data.rows;
                if (this.configures.carVersion) {
                    this.configures.carVersion.config.filter((val, index) => {
                        const tem = this.carStates.stockAll[index]
                        if (tem) {
                            console.log('typeof tem.detail=== "string"', typeof tem.detail === "string")
                            tem.detail = typeof tem.detail === "string" ? JSON.parse(tem.detail) : tem.detail
                            val.policy = tem.detail.carTypeDTO?.label;
                        }
                    })
                    this.versionList = [
                        ...this.configures["carVersion"].config.filter(
                            (value) => value.show || value.show == undefined
                        ),
                    ];
                }
            })
            car = this.getCarName(car);
            return new Promise(async (resolve) => {
                for (var i = 0; i < Object.keys(this.configures).length; i++) {
                    let key = Object.keys(this.configures)[i];
                    if (this.configures[key]) {
                        continue;
                    }
                    let value = key;

                    let url = `${getBasePath()}static/${car}/data/${value}.json`;
                    let { data } = await this.getJson(url);
                    let reg = new RegExp("{static}", "g");
                    let text = JSON.stringify(data).replace(
                        reg,
                        `static/${car}/${isMobilePhone() ? "mobile" : "pc"}/`
                    );
                    reg = new RegExp("{path}", "g");
                    let temStr = isMobilePhone()
                        ? `${car}/mobile`
                        : `${car}/pc`;
                    text = text.replace(reg, temStr);
                    reg = new RegExp("{platform}", "g");
                    text = text.replace(reg, isMobilePhone() ? "mobile" : "pc");
                    reg = new RegExp("{configure}", "g");
                    text = text.replace(reg, GLOBAL_VARS.online3D);
                    this.configures[key] = JSON.parse(text);
                    // this.configures[key] = data;
                }
                // if (!this.configures['carSeries']) {
                //     try {
                //         let { data: { result } } = await axios.get(this.global_vars.dongfengApi.car_series,{timeout: 2000});
                //         this.configures['carSeries'] = result;
                //         // if(this.configures['carSeries'] instanceof Array){
                //         //     this.configures['carSeries'].filter(value=>{
                //         //         if(this.configures['config'].carSeriesId==value.id){
                //         //             this.configures['carVersion'].filter(version=>{

                //         //             })
                //         //         }
                //         //     })
                //         // }
                //     }
                //     catch (error) {
                //         this.configures['carSeries'] = {};
                //     }
                // }
                if (!this.initDefaulted) {
                    this.initDefaultConfig();
                }
                document.title = this.configures["config"].car + "-VR看车";
                resolve(this.configures);
            });
        },
        /**
         * @description: 初始化默认车型参数
         * @return {*}
         */
        async initDefaultConfig() {
            this.initDefaulted = true;
            this.carStates.stockAll.length >= 0 && this.configures.carVersion.config.filter((val, index) => {
                const tem = this.carStates.stockAll[index]
                if (tem) {
                    console.log('typeof tem.detail=== "string"', typeof tem.detail === "string")
                    tem.detail = typeof tem.detail === "string" ? JSON.parse(tem.detail) : tem.detail
                    val.policy = tem.detail.carTypeDTO?.label;
                }
            })
            this.versionList = [
                ...this.configures["carVersion"].config.filter(
                    (value) => value.show || value.show == undefined
                ),
            ];
            let {
                car,
                carName,
                defaultColor,
                innerColor,
                pandectFov,
                fov,
                carSeries,
                carSeriesName,
                carSeriesId,
                nissanCarSeriesId,
                source_page = ''
            } = this.configures["config"];
            let {
                code: version,
                id: carType = 1,
                carId: carTypeId,
            } = this.configures["carVersion"].config.find(
                (version) => version.name == carName
            );
            let id, name_en;
            // try {
            //     let temData = this.configures['carSeries'].find(item => item.name.toLowerCase() == car.toLowerCase());
            //     id = temData ? temData.id : id;
            //     name_en = temData ? temData.name_en : name_en;
            // }
            // catch (error) {

            // }
            let sceneId = this.configures.scene.colorList[0].code;
            let insideLocationId =
                this.configures.inside.insideLocation[0].code;
            this.saveInitData({
                car,
                carName,
                carType,
                source_page,
                carTypeId,
                defaultColor,
                defaultInnerColor: innerColor,
                version,
                innerColor,
                carSeries: name_en ?? carSeries,
                carSeriesId: id ?? carSeriesId,
                carSeriesName,
                sceneId,
                insideLocationId,
                pandectFov,
                fov,
                totalStep: this.configures.config.blockOption ? 4 : 5,
                nissanCarSeriesId,
                showSceneBtn:
                    this.configures.scene.showSceneBtn != undefined
                        ? this.configures.scene.showSceneBtn
                        : this.carStates.showSceneBtn,
            });
            this.carStates.preferencesUrl = this.isNissan
                ? `https://www.dongfeng-nissan.com.cn/car-configuration-preferences-page?car_series_id=${nissanCarSeriesId}`
                : this.configures.config.preferencesUrl;
            this.updateDefualtColor();
            this.carStates.tabs = [];
            for (var i = 0; i < this.configures.nav.router.length; i++) {
                let nav = this.configures.nav.router[i];
                if (nav.name == "pandect") {
                    break;
                } else {
                    this.carStates.tabs.push(nav);
                }
            }
            this.assembleList = this.configures.options.assemble ?? [];
            let totalStep = 5;
            for (var i = 0; i < this.configures.nav.router.length; i++) {
                if (this.configures.nav.router[i].name == "pandect") {
                    totalStep = i + 1;
                }
                this.names[i] = this.configures.nav.router[i].name;
            }
            this.carStates.totalStep = totalStep;
            this.carStates.preferential =
                this.configures.config.preferential ??
                this.carStates.preferential;
            this.carStates.preferential =
                this.configures.config.policy ??
                this.carStates.policy;
            this.carStates.blockRightButtons =
                this.configures.config.blockRightButtons ??
                this.carStates.blockRightButtons;
            if (this.$route.name == "version") {
                let { status, oCode, iCode } = this.$route.query;
                if (this.carStates.carSeries == "VX6" && oCode == "pink") {
                    oCode = "red";
                }
                if (status && oCode && iCode) {
                    let outColor = this.getOutsideColorList().find(
                        (value) => value.code == oCode
                    ).name;
                    this.carStates.outColor = outColor;
                    this.carStates.outColorcode = oCode;
                    let innerColor = this.getInsideColorList().find(
                        (value) => value.code == iCode
                    ).name;
                    innerColor &&
                        outColor &&
                        this.saveInitData(
                            {
                                outColor,
                                innerColor,
                                outColorcode: oCode,
                                innerColorcode: iCode,
                            },
                            false
                        );
                }
            }
            const b = await isUser();
            if (b) {
                const logid = getQueryString("logid");
                await getConfig(getQueryString("logid"), this.saveInitData);
                if (logid) {
                    if (isMobilePhone()) {
                        document.getElementById("kefuBtn").click();
                    } else {
                        showChatDialog({
                            showOrHide: "show",
                        });
                    }
                }
            }
        },
        /**
         * @description: 通过路径去取json
         * @param {*} url
         * @return {*}
         */
        getJson(url) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: url,
                    dataType: "json",
                    crossDomain: true,
                    cache: false,
                })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * @description: 预约试驾
         * @param {*} data
         * @return {*}
         */
        async testDrive(data) {
            let {
                car,
                carName,
                carSeriesId,
                carTypeId,
                carType,
                outColor,
                innerColor,
                price,
                options,
            } = this.carStates;
            let optionsStr = options.length > 0 ? "精品:" : "";
            options.filter((value) => optionsStr.concat(value.name));
            const res = await axios.post(
                getBasePath() + this.global_vars.dongfengApi.clue,
                {
                    user_name: data.user_name,
                    phone: data.phone,
                    store_codes: data.dealer_codes,
                    page_id: "",
                    source: 126,
                    clue_name: `${car}3D配置器`,
                    clue_url: location.href.replace(location.search, ""),
                    clue_type: 2,
                    is_send: 0,
                    terminal: isMobilePhone() ? "wap" : "pc",
                    car_series_id: carSeriesId,
                    car_type_id: "",
                    smart_code: "",
                }
            );
            res.data &&
                res.data.errcode == 200 &&
                this.track("c_20230511171626_y021", {
                    page_title: this.carStates.pageTitle,
                    btn_name: "立即预约",
                    car_title: document.title,
                    clue_id: res.data.result.extsystem_clue_id,
                    car_version: this.carStates.carName,
                    car_outside: this.carStates.outColor,
                    car_inside: this.carStates.innerColor,
                    is_success: 1,
                });
            return res;
        },
        /**
         * @description: 获取缓存
         * @param {*} name
         * @return {*}
         */
        getCookie(name) {
            let arr,
                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            let cookies = document.cookie;
            if ((arr = cookies.match(reg))) {
                let cookieArr = arr[2].split("|");
                let cookieID = cookieArr[0];
                return cookieID;
            } else return null;
        },
        /**
         * @description: 格式化价格
         * @param {*} num
         * @return {*}
         */
        toThousands(num) {
            var result = [],
                counter = 0;
            num = (num || 0).toString().split("");
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result.unshift(num[i]);
                if (!(counter % 3) && i != 0) {
                    result.unshift(",");
                }
            }
            return result.join("");
        },
        /**
         * @description: 获取分享链接
         * @return {*}
         */
        getShowLink() {
            let { carType, innerColorcode, outColorcode, options, assembles } =
                this.carStates;
            let optionStr = "";
            let assemblesStr = "";
            options.filter((o) => (optionStr += o.id));
            assembles.filter((o) => (assemblesStr += o.id));
            return `${window.location.href}${window.location.href.indexOf('?') != -1 ? '&' : '?'}carType=${carType}&outColor=${outColorcode}&innerColor=${innerColorcode}&options=${optionStr}&assembles=${assemblesStr}&fromto=1`;
        },
        /**
         * @description: 步棸更新
         * @param {*} router
         * @param {*} car
         * @return {*}
         */
        async onStepUpdate(router, car) {
            let arr = ["carType", "outColor", "innerColor", "options"];
            if (
                router.currentRoute.value.name == "pandect" &&
                arr.filter((value) => this.$route.query[value] != undefined)
                    .length == arr.length
            ) {
                await this.loadConfigure(car);
                let {
                    carType,
                    outColor: outColorcode,
                    innerColor: innerColorcode,
                } = this.$route.query;
                let item = this.configures.carVersion.config.find(
                    (v) => v.id == carType
                );
                let { name: carName, code: version, carId: carTypeId } = item;
                this.saveInitData({
                    carName,
                    version,
                    carType,
                    carTypeId,
                });
                let oids = this.$route.query.options.split(",");
                let options = this.getOptionList().filter(
                    (o) => oids.indexOf(o.id.toString()) != -1
                );
                let aids = this.$route.query.assembles.split(",");
                let temArr = this.configures.options.assemble ?? [];
                let assembles = temArr.filter(
                    (o) => aids.indexOf(o.id.toString()) != -1
                );
                outColorcode = this.getOutsideColorList().find(
                    (value) => value.code == outColorcode
                )
                    ? outColorcode
                    : this.getOutsideColorList()[0].code;
                innerColorcode = this.getInsideColorList().find(
                    (value) => value.code == innerColorcode
                )
                    ? innerColorcode
                    : this.getInsideColorList()[0].code;
                this.saveInitData(
                    {
                        outColorcode,
                        innerColorcode,
                        options,
                        assembles,
                        step: this.carStates.totalStep,
                    },
                    true
                );
                let outColor = this.getOutsideColorList().find(
                    (value) => value.code == outColorcode
                ).name;
                let innerColor = this.getInsideColorList().find(
                    (value) => value.code == innerColorcode
                ).name;
                this.saveInitData({ outColor, innerColor }, false);
            } else if (
                router.currentRoute.value.name !=
                this.names[this.carStates.step - 1]
            ) {
                router.replace({
                    name: this.names[this.carStates.step - 1],
                    query: this.$route.query,
                });
            }
        },
        getUserPhone() {
            return this.userPhone;
        },
        isInDouyin() {
            if (
                this.getQueryString("terminal_type") &&
                this.getQueryString("terminal_type").indexOf("tt") != -1
            ) {
                return true;
            }
            return false;
        },
        showMarker() {
            this.saveInitData({ showMarker: !this.carStates.showMarker });
            WebglMessageEvent.SHOW_MARRKER.data = this.carStates.showMarker;
            window.document
                .getElementsByClassName("car")[0]
                .contentWindow.postMessage(WebglMessageEvent.SHOW_MARRKER);
            this.track("c_20230511171626_l005", {
                page_title: "版本页",
                btn_name: "亮点按钮",
                btn_status: this.carStates.showMarker ? 1 : 0,
            });
        },
        driveModel() {
            this.saveInitData({
                isDriveModel: !this.carStates.isDriveModel,
                showMarker: false,
                sceneId: 0,
            });
            this.track(
                this.carStates.isDriveModel
                    ? "c_20230511171626_z022"
                    : "c_20230511171626_c023",
                {
                    btn_name: this.carStates.isDriveModel ? "驾驶模式" : "退出",
                    page_title: "驾驶模式页",
                }
            );
        },
        jumpStep(step, material_name) {
            let names = ["版本修改", "外观修改", "内饰修改", "精品修改"];
            this.saveInitData({ step }, false);
            this.track("c_20230511171626_h020", {
                page_title: "定制页",
                btn_name: `${names[step - 1]}`,
                material_name,
            });
        },
        setScene(sceneId, btn_name) {
            this.saveInitData({ sceneId });
            this.track("c_20230511171626_s009", {
                btn_name,
            });
        },
        switchWebgl(car) {
            car.switchWebgl();
            this.track("click_car_vr_quick_23201846e011", {
                page_title: this.carStates.pageTitle,
                btn_name: "极速版",
            });
        },
        /**
         * @description: 发送埋点事件
         * @param {*} info 事件信息
         * @return {*}
         */
        track(eventId, info, related = true) {
            const { carSeriesId: car_series_id, carName, car } = this.carStates;
            const car_title = car + carName;
            let eventInfo = related
                ? { ...info, ...{ car_series_id, car_title } }
                : { ...info };
            try {
                dndcAnalytics(
                    "send",
                    "track",
                    !eventInfo ? { eventId } : { eventId, eventInfo }
                );
            } catch (error) {
                console.log(error);
            }
        },
        startCountDown() {
            if (this.activityTime > 0) {
                setTimeout(() => {
                    this.activityTime--;
                    this.startCountDown();
                }, 1000);
            } else {
                finishTask();
            }
        },
    },
    async mounted() {
        // const geolocation = new BMap.Geolocation();
        // console.log(geolocation);
        //
        // await geolocation.getCurrentPosition((res) => {
        //     this.address = res;
        //     console.log("this.address", this.address);
        // });
        if (getQueryString("activityTime")) {
            this.activityTime = Number(getQueryString("activityTime"));
            this.activityTime > 0 && this.startCountDown();
        }
        const res = await getLocation();
        this.address = res;
        this.userPhone = await getUserPhone();
        console.log("address:", this.address);
    },
};
</script>

<template>
    <RouterView />
</template>

<style lang="scss">
@import "./assets/fonts/iconfont.css";

// @font-face {
//     font-family: 'NissanBrandRegular';
//     src: url('~@static/common/fonts/NissanBrandRegular.woff2');
// }
body {
    --ative-color: #2ed9c3;
    --swiper-theme-color: #f5f5f5;
    --button-border-color: #292c33;
    --button-text-color: #000000;
    --button-bg-color: #ffffff;
    --next-btn-hover-color: #31bfac;
    font-family: NissanBrandRegular, PingFangSC-Light, Microsoft Yahei, SimHei,
        "sans-serif" !important;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.justify-start {
    display: flex;
    justify-content: flex-start;
}

.justify-center {
    display: flex;
    justify-content: center;
}

.justify-end {
    display: flex;
    justify-content: flex-end;
}

.justify-evenly {
    display: flex;
    justify-content: space-evenly;
}

.justify-around {
    display: flex;
    justify-content: space-around;
}

.justify-between {
    display: flex;
    justify-content: space-between;
}

.items-start {
    display: flex;
    align-items: flex-start;
}

.items-center {
    display: flex;
    align-items: center;
}

.items-end {
    display: flex;
    align-items: flex-end;
}
</style>
